import { Directive, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ChartDataset } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { TranslocoService } from '@ngneat/transloco';
import { CalculatorResult } from '../../../models/analysis/solar-calculator-result';
import { UnsubscribeOnDestroyAdapter } from '../../../adapters/unsubscibe-on-destroy.adapter';
import { LanguageService } from '../../../../services/language.service';
import { ResultChartsService } from '../../../../services/result-charts.service';

@Directive()
export abstract class BaseResultChartComponent<T = CalculatorResult> extends UnsubscribeOnDestroyAdapter implements OnInit {
  @ViewChildren(BaseChartDirective) charts: QueryList<BaseChartDirective>;


  public calculatorResultValue: T;

  get solarCalculatorResult() {
    return this.calculatorResultValue;
  }

  @Input()
  set solarCalculatorResult(value: T) {
    this.calculatorResultValue = value;
    if (!value) {
      return;
    }
    this.onInputDataChange();
    this.onLanguageChange();
    this.setChartData();
    this.updateCharts();
  }

  constructor(
    protected languageService: LanguageService,
    protected translocoService: TranslocoService,
    protected resultChartsService: ResultChartsService,
  ) {
    super();
  }


  ngOnInit() {
    this.subs.sink = this.languageService.languageChanged$.subscribe(() => {
      this.onLanguageChange();
      this.updateCharts();
    });
  }

  subscribeToLabelTranslation(translationKey: string, dataset: ChartDataset) {
    this.subs.sink = this.translocoService.selectTranslate(`calculator_result.chart.${ translationKey }`)
      .subscribe((translation) => {
        dataset.label = translation;
        this.updateCharts();
      });
  }

  updateCharts() {
    if (!this.charts) {
      return;
    }
    this.charts.forEach((chart) => {
      chart.update();
    });
  }

  protected abstract setChartData(): void;

  protected onLanguageChange() {

  }

  protected onInputDataChange() {

  }
}
